// Every endpoint is built from one base var, so pointing the UI at a different
// backend is a single change in .env rather than a search across the codebase.
//
// Nothing here is secret: Vite inlines VITE_* into the shipped bundle.

// Shared Vision backend — same login as the other Binny products.
const VISION = import.meta.env.VITE_VISION_BACKEND_URL || ''

export const LOGIN_URL = VISION ? `${VISION}/api/v1/users/login` : ''
export const ME_URL = VISION ? `${VISION}/api/v1/users/me` : ''
export const LOGOUT_URL = VISION ? `${VISION}/api/v1/users/logout` : ''

/**
 * Our own side of the ledger, from Binny Track.
 *
 * Same host as the login, different API version and prefix — hence its own
 * constant rather than reusing the `/api/v1/users` base above. Called straight
 * from the browser with the signed-in user's own bearer token, so what a person
 * can see here is exactly what that account is allowed to see; lereco does not
 * hold a service credential for it and cannot widen that.
 */
export const LEDGER_URL = VISION ? `${VISION}/api/v9/trackApp/ledger` : ''

